module.exports = __webpack_public_path__ + "img/ssggyh.0fc7ab78.png";